const thousandsRegex = /\B(?=(\d{3})+(?!\d))/g;
const zeroCentsRegex = /,00$/;
/**
 * This will format the price into a double digit number with an optional prefixed euroSign
 */
export const formatPrice = (price, { euroSign = true, decimals = 2, roundUp = false, abbreviateCents = false, } = {}) => {
    const priceToFormat = roundUp ? Math.ceil(price) : price;
    // Add thousands separator to price and optional euro sign
    let formattedPrice = `${euroSign ? '€\u00a0' : ''}${priceToFormat
        .toFixed(decimals)
        .replace('.', ',')}`.replace(thousandsRegex, '.');
    // shorten zero cents to ,-
    if (abbreviateCents) {
        formattedPrice = formattedPrice.replace(zeroCentsRegex, ',-');
    }
    return formattedPrice;
};
